module.exports = __webpack_public_path__ + "static/media/Lato-Light.2fe27d9d.ttf";